import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/assets/images/bgillustra/fonds.svg')" }}
    >
      <div className="flex flex-col items-center w-full max-w-md mx-4">
        {/* Logo Braincrea (centré, au‑dessus du formulaire) */}
        <div className="flex justify-center mb-6">
          <img
            src="/assets/logo/LogoBrainCreablack.png"
            alt="Braincrea"
            className="h-20 w-auto object-contain"
          />
        </div>

        {/* Carte du formulaire avec fond vert */}
        <div
          className="relative w-full rounded-2xl shadow-2xl overflow-hidden"
          style={{
            backgroundImage: "url('/assets/images/bgillustra/fondvert.jpeg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {/* Overlay sombre pour lisibilité */}
          <div className="absolute inset-0 bg-black/50" />
          {/* Contenu du formulaire */}
          <div className="relative z-10 p-6 md:p-8">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;